import { DataPoint } from '@src/types/DataPoint';
import { Device } from '@src/types/Device';
import { useMemo } from 'react';
import { getRows } from '../rowUtils';
import { DeviceDataTableRow } from '../types';

interface UseDeviceTableRowsOptions {
  dataPoints: DataPoint[];
  devices?: Device[];
}

const useDeviceTableRows = ({
  dataPoints,
  devices,
}: UseDeviceTableRowsOptions): DeviceDataTableRow[] =>
  useMemo(() => getRows(dataPoints, devices), [dataPoints, devices]);

export default useDeviceTableRows;
